import React from 'react';
import { getActiveIcon } from 'library/helpers';
import { THEME_NAMES } from 'selectors/tag.selectors';
import { AuditHistory } from 'components/Audit';
import { DocLink, DocPages } from 'components/Help/';
import { CanViewTravel } from 'library/permissions';
import LocationFormInput from './input';

const config = {
  init: {
    active: true
  },
  // List Table
  list: {
    // Table Columns
    columns: [
      {
        title: 'Code',
        dataIndex: 'code',
        width: '120px',
        align: 'center',
        sorter: true,
        defaultSortOrder: 'ascend'
      },
      {
        title: 'Name',
        dataIndex: 'name',
        sorter: true,
        defaultSortOrder: 'ascend'
      },
      {
        title: 'Timezone',
        dataIndex: 'timezone',
        sorter: true,
        defaultSortOrder: 'ascend'
      },
      {
        title: 'In Use',
        dataIndex: 'in_use',
        width: '120px',
        align: 'center',
        sorter: true,
        render: (text, record) => (record.in_use ? 'Yes' : 'No')
      },
      {
        title: 'Active',
        dataIndex: 'active',
        width: '120px',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [{
          text: 'Active',
          value: true
        }, {
          text: 'Inactive',
          value: false
        }],
        render: (text, record) => getActiveIcon(record.active)
      }
    ],
    // Deleting
    confirmMessage: item => (
      <div>
        <p>
          Are you sure you wish to delete the location
          <b>{item.name}</b>
          ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      code: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['code'],
        searchValue: ''
      },
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      },
      timezone: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['timezone'],
        searchValue: ''
      }
    },
    // General
    title: <DocLink page={DocPages.travelLocations}>Locations</DocLink>
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select a Location',
    title: 'Location',
    tabItems: [
      {
        key: 0,
        title: 'Details',
        component: props => (
          <LocationFormInput
            {...props}
            title="Location"
          />
        )
      },
      {
        key: 1,
        title: 'History',
        component: props => (
          <AuditHistory
            {...props}
            themeName={THEME_NAMES.location}
          />
        ),
        show: () => CanViewTravel()
          .hasPermissions()
      }
    ]
  }
};

export default config;
